// Reservation Table
export const APPROVE_RESERVATION_MESSAGE = "예약이 승인되었습니다.";
export const REJECT_RESERVATION_MESSAGE = "예약이 반려되었습니다.";
export const EMPTY_RESERVATION_LIST_MESSAGE = "예약 내역이 없습니다.";
export const CONFIRM_APPROVE_RESERVATION_MESSAGE =
  "해당 예약을 승인하려면 확인 버튼을 클릭하세요.";
export const CONFIRM_REJECT_RESERVATION_MESSAGE =
  "해당 예약을 반려하려면 확인 버튼을 클릭하세요.";

// User Table
export const APPROVE_USER_MESSAGE = "가입이 승인되었습니다.";
export const REJECT_USER_MESSAGE = "가입이 반려되었습니다.";
export const EMPTY_USER_LIST_MESSAGE = "회원 내역이 없습니다.";
export const CONFIRM_APPROVE_USER_MESSAGE =
  "해당 회원을 승인하려면 확인 버튼을 클릭하세요.";
export const CONFIRM_REJECT_USER_MESSAGE =
  "해당 회원을 반려하려면 확인 버튼을 클릭하세요.";
